import { render, staticRenderFns } from "./lookUpTheWord.vue?vue&type=template&id=7cb562bb&scoped=true"
import script from "./lookUpTheWord.vue?vue&type=script&lang=js"
export * from "./lookUpTheWord.vue?vue&type=script&lang=js"
import style0 from "./lookUpTheWord.vue?vue&type=style&index=0&id=7cb562bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb562bb",
  null
  
)

export default component.exports